import { useEffect } from "react";
import PropTypes from "prop-types";
import { FEATURES } from "@constants";

/**
 * PaymentsRedirect component handles the default redirect for the /payments route
 * When officerInvoicingV3 is enabled, it redirects to /payments/v4/estimates (Invoicing tab)
 * Otherwise, it redirects to /payments/list/review (Legacy/Officer tab)
 */
const PaymentsRedirect = ({ user, router }) => {
	useEffect(() => {
		const isOfficerInvoicingV3 = user.Features.some(
			f => f.toLowerCase() === FEATURES.OFFICER_INVOICING_V3,
		);

		if (isOfficerInvoicingV3) {
			router.replace("/payments/v4/estimates");
		} else {
			router.replace("/payments/list/review");
		}
	}, []);

	return null;
};

PaymentsRedirect.propTypes = {
	user: PropTypes.object.isRequired,
	router: PropTypes.object.isRequired,
};

export default PaymentsRedirect;
